const entryPoint = (process.env.REACT_APP_API_BASE || '/api').replace(/\/+$/, '')

// The server without its /api part, for code that writes the whole path itself (the
// WhatsApp section): '' on the real site, where the page and the API share one address, and
// http://localhost:4003 while developing. It comes from REACT_APP_API_BASE, the one setting
// the build already has, so a build cannot end up pointing at the machine of the visitor.
export const apiRoot = (base) => base.replace(/\/api$/, '')

export const API_URL = apiRoot(entryPoint)

export default entryPoint
